import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DeviceDetails from './pages/DeviceDetails';
import ScriptLibrary from './pages/ScriptLibrary';
import ServerStats from './pages/ServerStats';
import { API_BASE } from './config';

function App() {
  const [isAuthenticated, setIsAuthenticated] = React.useState<boolean | null>(null);

  // On mount, check if we have a valid session by calling a lightweight endpoint
  React.useEffect(() => {
    fetch(`${API_BASE}/api/devices?limit=1`, { credentials: 'include' })
      .then(res => {
        setIsAuthenticated(res.ok);
      })
      .catch(() => setIsAuthenticated(false));
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
  };

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE}/api/logout`, { method: 'POST', credentials: 'include' });
    } catch {}
    setIsAuthenticated(false);
  };

  if (isAuthenticated === null) {
    return null; // loading
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app-container">
      <nav className="glass-panel animate-fade-in" style={{ margin: '1rem', padding: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
          <a href="/" style={{ fontSize: '1.25rem', fontWeight: 600, color: 'var(--text-primary)', textDecoration: 'none' }}>RMM Dashboard</a>
          <a href="/scripts" style={{ fontSize: '0.9rem', fontWeight: 500, color: 'var(--text-secondary)', textDecoration: 'none' }}>Script Library</a>
          <a href="/server" style={{ fontSize: '0.9rem', fontWeight: 500, color: 'var(--text-secondary)', textDecoration: 'none' }}>Server Stats</a>
        </div>
        <button className="btn btn-secondary" onClick={handleLogout}>Logout</button>
      </nav>
      <main className="animate-fade-in" style={{ padding: '0 1rem 1rem 1rem' }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/devices/:id" element={<DeviceDetails />} />
          <Route path="/scripts" element={<ScriptLibrary />} />
          <Route path="/server" element={<ServerStats />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
